// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_p2-8K","current":"index_current_VpACE","search":"index_search_OXqcH"};